/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RealEstateOwnerDto } from './RealEstateOwnerDto';
import {
    RealEstateOwnerDtoFromJSON,
    RealEstateOwnerDtoFromJSONTyped,
    RealEstateOwnerDtoToJSON,
    RealEstateOwnerDtoToJSONTyped,
} from './RealEstateOwnerDto';
import type { RentalTypeEnum } from './RentalTypeEnum';
import {
    RentalTypeEnumFromJSON,
    RentalTypeEnumFromJSONTyped,
    RentalTypeEnumToJSON,
    RentalTypeEnumToJSONTyped,
} from './RentalTypeEnum';
import type { PropertyTypeEnum } from './PropertyTypeEnum';
import {
    PropertyTypeEnumFromJSON,
    PropertyTypeEnumFromJSONTyped,
    PropertyTypeEnumToJSON,
    PropertyTypeEnumToJSONTyped,
} from './PropertyTypeEnum';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface RealEstateDto
 */
export interface RealEstateDto {
    /**
     * 
     * @type {string}
     * @memberof RealEstateDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RealEstateDto
     */
    photoUrl?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof RealEstateDto
     */
    address: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof RealEstateDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof RealEstateDto
     */
    area: number;
    /**
     * 
     * @type {number}
     * @memberof RealEstateDto
     */
    roomCount: number;
    /**
     * 
     * @type {PropertyTypeEnum}
     * @memberof RealEstateDto
     */
    propertyType: PropertyTypeEnum;
    /**
     * 
     * @type {RentalTypeEnum}
     * @memberof RealEstateDto
     */
    rentalType?: RentalTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof RealEstateDto
     */
    charges?: number;
    /**
     * 
     * @type {number}
     * @memberof RealEstateDto
     */
    rentAmount?: number;
    /**
     * Unified list of all owners (natural persons and legal entities)
     * @type {Array<RealEstateOwnerDto>}
     * @memberof RealEstateDto
     */
    owners?: Array<RealEstateOwnerDto>;
}



/**
 * Check if a given object implements the RealEstateDto interface.
 */
export function instanceOfRealEstateDto(value: object): value is RealEstateDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('area' in value) || value['area'] === undefined) return false;
    if (!('roomCount' in value) || value['roomCount'] === undefined) return false;
    if (!('propertyType' in value) || value['propertyType'] === undefined) return false;
    return true;
}

export function RealEstateDtoFromJSON(json: any): RealEstateDto {
    return RealEstateDtoFromJSONTyped(json, false);
}

export function RealEstateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RealEstateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
        'address': AddressDtoFromJSON(json['address']),
        'name': json['name'],
        'area': json['area'],
        'roomCount': json['roomCount'],
        'propertyType': PropertyTypeEnumFromJSON(json['propertyType']),
        'rentalType': json['rentalType'] == null ? undefined : RentalTypeEnumFromJSON(json['rentalType']),
        'charges': json['charges'] == null ? undefined : json['charges'],
        'rentAmount': json['rentAmount'] == null ? undefined : json['rentAmount'],
        'owners': json['owners'] == null ? undefined : ((json['owners'] as Array<any>).map(RealEstateOwnerDtoFromJSON)),
    };
}

export function RealEstateDtoToJSON(json: any): RealEstateDto {
    return RealEstateDtoToJSONTyped(json, false);
}

export function RealEstateDtoToJSONTyped(value?: RealEstateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'photoUrl': value['photoUrl'],
        'address': AddressDtoToJSON(value['address']),
        'name': value['name'],
        'area': value['area'],
        'roomCount': value['roomCount'],
        'propertyType': PropertyTypeEnumToJSON(value['propertyType']),
        'rentalType': RentalTypeEnumToJSON(value['rentalType']),
        'charges': value['charges'],
        'rentAmount': value['rentAmount'],
        'owners': value['owners'] == null ? undefined : ((value['owners'] as Array<any>).map(RealEstateOwnerDtoToJSON)),
    };
}

